"use strict";

const _ = require('lodash');
const Controller = require('./controller');

let _alerts;
function getAlertsContainer() {
	if (!_alerts) {
		_alerts = document.getElementById('cm-alerts');
	}
	return _alerts;
}

const ALERT_TEMPLATE = require('../templates/alert.html');

class AlertController extends Controller {
	constructor(options) {
		super(Object.assign({
			icon: 'fa-cog fa-spin',
			css: 'alert-danger',
			id: _.uniqueId('cm-alert-')
		}, options));
		this._template = ALERT_TEMPLATE;
	}

	get id() {
		return this.options.id;
	}

	initContainer(options, callback) {
		if (this._container) {
			return callback(null, options);
		}

		let c = document.getElementById(this.id);
		if (c) {
			this._container = c;
			return callback(null, options);
		}

		let alerts = getAlertsContainer();
		c = document.createElement('div');
		c.id = this.id;
		alerts.appendChild(c);
		this._container = c;

		callback(null, options);
	}

	destroy() {
		if (this._container) {
			getAlertsContainer().removeChild(this._container);
			this._container = null;
		}
	}
}

exports.AlertController = AlertController;

const CRITICAL_ERROR_TEMPLATE = require('../templates/critical-error.html');

class CriticalErrorController extends Controller {
	constructor(options) {
		super(Object.assign({icon: 'fa-exclamation-triangle'}, options));
		this._template = CRITICAL_ERROR_TEMPLATE;
	}

	initContainer(options, callback) {
		let container = document.getElementsByClassName('container')[0];
		if (container) {
			// We replace top document container with this controller's content.
			// Application isn't supposed to work anymore.
			container.innerHTML = null;
			this._container = container;
		}
		callback(null, options);
	}

	draw(options, callback) {
		super.draw(options, callback);
	}

	destroy() {
		// Nah, you can't
		return this;
	}
}

exports.CriticalErrorController = CriticalErrorController;